export const init = () => {
    const cookieBanner = document.getElementById('cookieBanner');
    const validSpan = 3600000 * 24 * 180;
    const closeButton = document.getElementsByClassName('js-cookie-banner-close')[0];
    const date = new Date(Date.now() + validSpan).toUTCString();

    if (cookieBanner) {
        if (document.cookie.indexOf('readcookieagreement=') === -1) {
            cookieBanner.style.display = 'block';
        }
        closeButton.addEventListener('click', () => {
            cookieBanner.style.display = 'none';

            document.cookie = `readcookieagreement=true; expires="${date}";`;
        });
    }
}